import fetchServer from "../../fetchServer";


export default async function updateFlightSetting(data) {
  let result = {
    return: 0,
    msg: "Something went wrong updating flight settings!",
  };

  await fetchServer({ method: "PATCH", url: "/product/v1/flightSetting",data})
    .then((res) => {
      if (res?.data && !res?.data?.error) {
        result = { return: 1, msg: "Successful", data: res?.data?.data };
      } else if (res?.data?.error) result["msg"] = res.data.error;
    })
    .catch((err) => {
      console.log("Network Error!");
    });

  return result;
}
